/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import HideIf from "util/HideIf";
import CategoryViewItem from "../categories-viewer/CategoryViewItem";
import styles from "./department-menu.module.scss";
import DepartmentMenuParent from "./DepartmentMenuParent";

const DEPARTMENTS = [
  {
    id: "replacement-parts",
    icon: "replacement-parts",
    name: "Replacement Parts",
    url: "/replacement-parts",
    tabIndex: 2,
  },
  {
    id: "body-parts",
    icon: "body-parts",
    name: "Body Parts",
    url: "/automotive-body-parts",
    tabIndex: 4,
  },
  {
    id: "automotive-lightings",
    icon: "automotive-lightings",
    name: "Lightings",
    url: "/automotive-lightings",
    tabIndex: 3,
  },
  {
    id: "tools-equipment",
    icon: "tools-equipment",
    name: "Tools & Equipment",
    url: "/tools-and-equipment",
    tabIndex: 6,
  },
  {
    id: "exterior-parts",
    icon: "exterior-parts",
    name: "Exterior",
    url: "/exterior",
    tabIndex: 9,
  },
  {
    id: "interior-parts",
    icon: "interior-parts",
    name: "Interior",
    url: "/interior",
    tabIndex: 8,
  },
  {
    id: "performance-parts",
    icon: "performance-parts",
    name: "Performance Parts",
    url: "/performance-parts",
    tabIndex: 7,
  },
  {
    id: "wheels-tires",
    icon: "wheels-tires",
    name: "Wheels & Tires",
    url: "/wheels",
    tabIndex: 5,
  },
  {
    id: "specialty-parts",
    icon: "specialty-parts",
    name: "Specialty Parts",
    url: "/specialty-parts",
    tabIndex: 10,
  },
];

const DepartmentMenu = (props) => {
  const { onSelectItem, title = "" } = props;
  const { t } = useTranslation(["home", "category-map"]);

  const RenderCategoryViewItem = ({ department, className, children }) => {
    // for desktop
    if (onSelectItem) {
      return (
        <div>
          {children}
        </div>
      );
    }

    return (
      <CategoryViewItem
        categoryObj={{
          tier0: department.id,
        }}
        url={department.url}
        className={className}
      >
        {children}
      </CategoryViewItem>
    );
  };

  return (
    <div>
      <HideIf show={title}>
        <PAText
          component="h1"
          className={styles.department_menu_title}
          bold
          fontSize={FONT_SIZE[5]}
        >
          {title}
        </PAText>
      </HideIf>

      <Head>
        <link
          rel="preload"
          href="https://partsavatar.ca/cms/pubicImages/images/department-spritesheet-partsavatarV3.webp"
          as="image"
        />
      </Head>

      <div
        className={`department-menu ${styles.department_menu_container} ${styles.department_menu} ${styles.mobile_department_menu}`}
      >
        {
          DEPARTMENTS.map((department) => (
            <RenderCategoryViewItem
              key={department.id}
              department={department}
              className={`clearfix ${styles.department_item}`}
            >
              <DepartmentMenuParent onSelectItem={onSelectItem} department={department}>
                <div
                  className={classNames(
                      `media-object ${styles[department.icon]} ${styles.department_icon_mobile} center-block ${styles.department_icon}`,
                  )}
                />

                <PAText component="h3" className={styles.department_item_title} bold>
                  {t(department.name, { ns: "category-map" })}
                </PAText>
              </DepartmentMenuParent>
            </RenderCategoryViewItem>
          ))
        }
      </div>
    </div>
  );
};

export default DepartmentMenu;
